import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {PageContentService} from "../../../services/help/pagecontent.service";
import {PageContent} from '@app/models/help/pagecontent.model';
import {Section} from "@app/models/help/section.model";
import {SectionService} from "@app/services/help/section.service";

@Component({
  selector: 'app-helpcenter',
  templateUrl: './helpcenter.component.html',
  styleUrls: ['./helpcenter.component.scss']
})
export class HelpcenterComponent implements OnInit {

  public pageContents: PageContent[];
  public sections: Section[];

  public searchKeyword: string = '';
  public url: string;
  public displayMode: number;

  constructor(private pageContentService: PageContentService,
              private sectionService: SectionService,
              private route: ActivatedRoute,
              private router: Router) {
    this.url = window.location.origin;

    this.displayMode = 0;
  }

  public ngOnInit() {
    if (this.displayMode == 2) {
      this.bindSections();
    }
  }

  private bindSections() {
    this.sectionService.getList().subscribe(result => {
      this.sections = result;
    });
  }

  public search() {
    if (this.searchKeyword === '') {
      return;
    }
    this.router.navigateByUrl('/help/search?keyword=' + this.searchKeyword);
  }

  public navigateToPageContentDetail(id) {
    this.router.navigateByUrl('/help/pagecontent?id=' + id);
  }

  public navigateToPageByType(type: string, sectionId: number = null) {
    if (type === 'faq') {
      this.router.navigateByUrl('/help/faq');
    } else if (type === 'userguides') {
      this.displayMode = 2;
      this.bindSections();
    } else if (type === 'videos') {
      this.displayMode = 1;
    } else if (type === 'sections') {
      this.displayMode = 1;
      this.pageContentService.search(sectionId, '').subscribe(result => {
        this.pageContents = <PageContent[]>result;
      });
    }
  }
}
